// RadicalScreenVideos.jsx
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { Stack } from "@mui/system";

const VIDEOS = [
    {
        title: "Explicación Web para generar recetas",
        youtubeId: "Gc18NQ6C61Y",
        description:
            "Explicación de las herramientas en la web para generar recetas",
        id: "ExplicacionWeb",
    },
    {
        title: "21 Cartas",
        youtubeId: "nv0kmybn1dQ",
        description:
            "Versión de las 21 cartas en el que la carta acaba en la posición deseada por el espectador. Además, cada uno de los repartos es diferente. ",
        id: "VeintiunaCartas",
    },
    {
        title: "Ovejas y Pastores",
        youtubeId: "MfHLy79N2rM",
        description:
            "Juego en el que un grupo de ovejas y pastores se van a pastar. Aunque el espectador los mezcla, al final acaban en orden.",
        id: "OvejasYPastores",
    },
    {
        title: "Cuadrado Mágico",
        youtubeId: "RYNGAlY2Z6o",
        description:
            "Cuadrado mágico con cartas, en el que el espectador mezcla las cartas y escoge el número en el momento.",
        id: "CuadradoMagico",
    },
    {
        title: "8 espectadores",
        youtubeId: "Mn6zFKSB-2U",
        description:
            "4 espectadores mezclan la baraja, y otros 4 escogen como se repartirá en paquetes. Al terminar de repartir, la baraja estará ordenada.",
        id: "OchoEspectadores",
    },
    {
        title: "Ritual del Viento - En vivo - Memorial Ascanio 2026",
        youtubeId: "Qy7jY1eAqk0",
        description:
            "Vídeo en vivo del Ritual del Viento celebrado en el Memorial Ascanio 2026.",
        id: "RitualDelViento",
    },
];

const RadicalScreenVideos = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!location.hash) return;

        const id = decodeURIComponent(location.hash.replace("#", ""));

        requestAnimationFrame(() => {
            document.getElementById(id)?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        });
    }, [location.hash]);
    return (
        <Box sx={{ p: 2, maxWidth: 900, mx: "auto" }}>
            <Stack
                direction="row"
                spacing={2}
                sx={{
                    mb: 3,
                    justifyContent: "space-around",
                    alignItems: "center",
                }}
            >
                <Typography variant="h5" sx={{ mb: 3 }}>
                    Ordenación Radical - Vídeos explicativos
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate("/tools/radical")}
                >
                    Herramienta
                </Button>
            </Stack>

            {VIDEOS.map((video, index) => (
                <Card
                    key={video.id}
                    id={video.id}
                    sx={{ mb: 3, scrollMarginTop: 24 }}
                >
                    <CardContent>
                        <Typography variant="h6" sx={{ mb: 0.5 }}>
                            {video.title}
                        </Typography>

                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mb: 2 }}
                        >
                            {video.description}
                        </Typography>

                        <Box
                            component="iframe"
                            src={`https://www.youtube.com/embed/${video.youtubeId}`}
                            title={video.title}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                            sx={{
                                width: "100%",
                                aspectRatio: "16 / 9",
                                border: 0,
                                borderRadius: 1,
                            }}
                        />
                    </CardContent>
                </Card>
            ))}
        </Box>
    );
};

export default RadicalScreenVideos;
